<template lang="pug">
#app
  //- .wrapper(:class="{ 'nav-open' : navOpened }" v-if="!onAuthenticated()")
  //-   Login
  md-notifications
  .wrapper(v-if="this.$route.name !== undefined && lstRouteFront.includes(this.$route.name) ")
    router-view
    md-footer(v-if="lstRouteFrontFooter.includes(this.$route.name)")
  .wrapper(:class="{ 'nav-open' : navOpened }" v-else)
    md-header(v-if="onHomePage()")
    sidebar(:open='navOpened' v-if="!onHomePage() && onAuthenticated()")
    .main-panel(v-if="!onHomePage() && onAuthenticated()")
      navigation(@toggleSideBar='toggleSideBar' v-if="!onHomePage() && onAuthenticated()")
      router-view
    router-view(v-else)
    .clearfix
    md-footer(v-if="onHomePage()")
    .close-layer(v-if='navOpened', @click='onCloseLayerClick')
  v-dialog
  //- modals-container
</template>

<script>
import Navigation from '@/components/Navigation'
import MdFooter from '@/components/Front/Footer'
import Sidebar from '@/components/Sidebar'
// import gql from 'graphql-tag'
// import graphql from '@/components/Model/graphql'
// import firebase from 'firebase'
import Login from './components/Account/Login'
import MdHeader from '@/components/Front/Header'
import MdBody from '@/components/Front/Body'
export default {
  name: 'app',
  metaInfo: {
    title: 'Obee Website',
    meta: [
      {name: 'description', content: 'I have things here on my site.'}
    ]
  },
  components: {
    MdHeader,
    Navigation,
    Sidebar,
    Login,
    MdBody,
    MdFooter
  },

  data() {
    return {
      loader: null,
      sidebarToggled: false,
      widthFull: null,
      lstRouteFront: ['general_step', 'join_classes', 'landing', 'landing_lesson', 'landing_lesson_detail', 'landing_video', 'landing_video_detail', 'landing_exercise', 'landing_exercise_detail', 'landing_exercise_detail_result'],
      lstRouteFrontFooter: ['landing', 'landing_lesson', 'landing_lesson_detail', 'landing_video', 'landing_video_detail', 'landing_exercise']
    }
  },

  computed: {
    navOpened() {
      return this.sidebarToggled
    }
  },

  mounted() {
    this.onLoadingPage()
    this.initMaterial()
  },

  updated() {
    this.initMaterial()
  },
  methods: {
    initMaterial() {
      $.material.init() // eslint-disable-line
    },
    toggleSideBar() {
      // console.log('========App vue toogle======')
      this.sidebarToggled = !this.sidebarToggled
    },
    onCloseLayerClick() {
      this.toggleSideBar()
    },
    onAuthenticated() {
      if (!this.$store.getters.isLoggedIn) {
        return false
      }
      return true
    },
    onHomePage() {
      if (!this.$store.getters.isHomePage) {
        return false
      }
      return true
    },
    onLoadingPage() {
      if (this.$route.name === 'Account') {
        if (document.readyState === 'complete' && this.loader !== null) {
          this.loader.hide()
        } else {
          this.show()
        }
      }
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    }
  }
}
</script>

<style lang="scss">
@import "./assets/sass/md/_variables.scss";

.table {
  thead {
    th {
      font-weight: $headings-font-weight;
    }
  }
}
html, body {height: 100%;}
select { 
  appearance:none;
  /* for Firefox */ 
  -moz-appearance: none; 
  /* for Safari, Chrome, Opera */ 
  -webkit-appearance: none; 
} 
/* for IE10 */ 
select::-ms-expand { 
  display: none; 
} 
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url('assets/images/faces/ic_arrow_down.png') !important;
  background-position: 99% !important;
  background-size: 12px !important;
  background-repeat: no-repeat !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}

@media (min-width: 992px) {
  .typo-line {
    padding-left: 140px;
    margin-bottom: 40px;
    position: relative;
    .category {
      transform: translateY(-50%);
      top: 50%;
      left: 0px;
      position: absolute;
    }
  }
  .fullWidth {
    width: 100%;
  }
}

.places-buttons .btn {
  margin-bottom: 30px;
}

.space-70 {
  height: 70px;
  display: block;
}

.sidebar .nav > li.active-pro {
  position: absolute;
  width: 100%;
  bottom: 10px;
}

.tim-row {
  margin-bottom: 20px;
  padding-top: 50px;
  h3 {
    margin-top: 0;
  }
}

.tim-typo {
  padding-left: 25%;
  margin-bottom: 40px;
  position: relative;
  .tim-note {
    bottom: 10px;
    color: #c0c1c2;
    display: block;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    left: 0;
    margin-left: 20px;
    position: absolute;
    width: 260px;
  }
}
</style>




// WEBPACK FOOTER //
// App.vue?ac383a66